import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyJoin } from "@/components/MatchKey/MatchKeyShell";
import { CHESS_CFG } from "@/components/MatchKey/cfgs";

export default function ChessJoinPage() {
  useEerieBackdrop("estampie");
  return <MatchKeyJoin cfg={CHESS_CFG} />;
}
